/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';
import axios from 'axios';
import { Auth } from 'aws-amplify';
import { eraseCookie } from '../../components/LandingPage/helpers/cookieHelper';

class Logout extends React.Component {
	componentDidMount() {
		var redirectInfo = localStorage.getItem('redirectInfo');
		if (redirectInfo) { // For handling a redirect back from the Cognito Hosted UI
			console.log("first scenario  redirectInfo " + redirectInfo)
			localStorage.removeItem('redirectInfo');
			var rdJSON = JSON.parse(redirectInfo);
			let redirect =  rdJSON['redirectURI'];
			console.info(" redirect" +  redirect);
			if(!redirect.includes('.wavebl.com')){
				console.error(" redirect" +  redirect);
				redirect = null;
			}
			if (rdJSON['clientID'] && rdJSON['logoutURI']) { // Redirect back to client
				axios.get('/verifyClient', {
					params: {
						client_id: rdJSON['clientID'],
						logout_uri: rdJSON['logoutURI']
					}
				}).then(response => {
					if (response.status === 200) {
						window.location.assign(rdJSON['logoutURI']);
					}
				}).catch(error => {
					console.error(error.response)
					window.location.href = '/';
				});
			}
			else if (rdJSON['responseType'] === "id_token" && rdJSON['clientID'] && redirect) { // Call authorize endpoint to start implicit flow
				let authorizeEndpointPath = '/oauth2/authorize/?response_type=' + rdJSON['responseType']
					+ "&client_id=" + rdJSON['clientID'] + "&redirect_uri=" + redirect;
				window.location.href = authorizeEndpointPath;
			}
			else if (rdJSON['responseType'] && rdJSON['clientID'] && redirect && rdJSON['codeChallenge'] && rdJSON['codeChallengeMethod']) { // Call authorize endpoint to start PKCE flow
				let authorizeEndpointPath = '/oauth2/authorize/?response_type=' + rdJSON['responseType'] + "&client_id=" + rdJSON['clientID']
					+ "&redirect_uri=" + redirect + "&code_challenge=" + rdJSON['codeChallenge']
					+ "&code_challenge_method=" + rdJSON['codeChallengeMethod'];
				window.location.href = authorizeEndpointPath;
			}
			else if (rdJSON['responseType'] && rdJSON['clientID'] && redirect ) { // just redirect to redirectURI
				// let redirect =  rdJSON['redirectURI'];

				console.log("first scenario redirecting to  " + redirect );
				window.location.href = redirect;
			}
			else { // Default to redirecting to the broker login page
				window.location.href = '/';
			}
		}
		else { // If the logout endpoint is being called before the user has been logged out
			// Erase the token cookies
			console.log("second scenario " )
			eraseCookie("id_token");
			eraseCookie("access_token");
			eraseCookie("refresh_token");

			// Accept requests according to https://docs.aws.amazon.com/cognito/latest/developerguide/logout-endpoint.html
			let queryStringParams = new URLSearchParams(window.location.search);
			let clientID = queryStringParams.get('client_id');
			let logoutURI = queryStringParams.get('logout_uri');
			let redirectURI = queryStringParams.get('redirect_uri');
			let responseType = queryStringParams.get('response_type');
			let codeChallenge = queryStringParams.get('code_challenge');
			let codeChallengeMethod = queryStringParams.get('code_challenge_method');

			// Store the redirect info in local storage before calling the Cognito Hosted UI to logout
			var redirectObject;
			if (clientID && logoutURI) { // For redirect to client
				console.log("second scenario 1" )
				redirectObject = { 'clientID': clientID, 'logoutURI': logoutURI };
			}
			else if (responseType === "id_token" && clientID && redirectURI) { // For implicit flow
				console.log("second scenario 2" )
				redirectObject = { 'clientID': clientID, 'responseType': responseType, 'redirectURI': redirectURI };
			}
			else if (responseType === "code" && clientID && redirectURI && codeChallenge && codeChallengeMethod) { // For PKCE flow
				console.log("second scenario 3" )
				redirectObject = { 'clientID': clientID, 'responseType': responseType, 'redirectURI': redirectURI, 'codeChallenge': codeChallenge, 'codeChallengeMethod': codeChallengeMethod };
			}
			else if (responseType === "code" && clientID && redirectURI) {
				console.log("The Fix" )
				console.log("redirectURI " + redirectURI)
				redirectObject = { 'clientID': clientID, 'responseType': responseType, 'redirectURI': redirectURI };
			}
			else {
				console.log("second scenario 4" )
				redirectObject = { 'redirect': 'broker' };
			}
			console.log("second scenario redirectObject " + redirectObject )
			localStorage.setItem('redirectInfo', JSON.stringify(redirectObject));

			// We remove the client-id used for last login
			localStorage.removeItem('client-id');

			Auth.signOut().then(() => { // Sign the user out
				window.location.reload(); // Reload the page to handle the client redirect
			}).catch(error => {
				console.error(error)
			});
		}
	}

	render() { return null; }
}

export default Logout;
